import { createActions, createReducer } from "reduxsauce"
import { call, getContext, put, takeLatest } from "redux-saga/effects"
import { get } from "lodash"
import { log } from "helpers/logger"
import { post as apiPost, get as apiGet } from "api"
import { receiveUser } from "../../../actions/user"

export const { Types, Creators } = createActions({
  setError: ["error"],
  deleteError: [],
  setPassword: ["payload"],
  setPasswordError: ["error"],
}, {
  prefix: "ompnt/modules/setPassword/",
})

const DEFAULT_STATE = {
  passwordSet: false,
  error: null,
}

function handleSetError(state, { error }) {
  return { ...state, error }
}

function handleDeleteError(state) {
  return { ...state, error: null }
}

function handleSetPassword(state) {
  return { ...state, passwordSet: false }
}

function handleSetPasswordError(state, { error }) {
  return { ...state, error }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_ERROR]: handleSetError,
  [Types.DELETE_ERROR]: handleDeleteError,
  [Types.SET_PASSWORD]: handleSetPassword,
  [Types.SET_PASSWORD_ERROR]: handleSetPasswordError,
})

function* setPassword({ payload }) {
  if (payload) {
    try {
      // This call the user's not logged in, but a cookie will be returned is successful
      yield call(apiPost, "/api/users/reset-password", payload, true)

      // This call is using the session cookie to identify the user
      const { user } = yield call(apiGet, "/api/users/me", true)
      yield put(receiveUser(user))

      const { navigate } = yield getContext("router")
      yield call(navigate, "/")
    } catch (err) {
      const errorMessage = get(err, "error.text")
      if (!errorMessage) {
        log(err)
        yield put(Creators.setPasswordError("An unexpected error happened."))
      }
      yield put(Creators.setPasswordError(errorMessage))
    }
  }
}

export function* saga() {
  yield takeLatest(Types.SET_PASSWORD, setPassword)
}
